var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 241,
    viewBox: "0 0 216 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.7 105.803L48.8117 155.009L2.6673 159.005L0 189.109L6.40153 182.715C6.40153 182.715 75.4847 197.101 91.4885 182.715C107.492 168.329 69.215 114.8 69.215 114.8",
    fill: "#5100CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1996 128L48.8098 155.008L20.0436 157.499C18.9395 162.949 18.3897 168.496 18.4026 174.056C18.4 177.719 18.6349 181.378 19.1056 185.011C31.7934 187.076 51.6838 189.686 67.8885 188.993C68.7789 184.064 69.2222 179.065 69.2131 174.056C69.2131 150.991 60.1374 131.829 48.1996 128V128Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0962 105.802C62.0962 105.802 67.4807 193.579 52.2727 235.138L55.4495 239.8H28.4004C28.4004 239.8 25.4453 128.152 25.4453 104.055L62.0962 105.802Z",
    fill: "#5100CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0969 105.803C62.0969 105.803 67.4814 193.58 52.2734 235.139L55.4501 239.8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1138 37.8882V49.2956L38.9648 52.7687V33.518L53.1138 30.0449V37.8882Z",
    fill: "#EDEEEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1244 41.8358C45.3333 41.8358 45.5027 41.6666 45.5027 41.4579C45.5027 41.2492 45.3333 41.0801 45.1244 41.0801C44.9155 41.0801 44.7461 41.2492 44.7461 41.4579C44.7461 41.6666 44.9155 41.8358 45.1244 41.8358Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.933 41.8358C51.1419 41.8358 51.3113 41.6666 51.3113 41.4579C51.3113 41.2492 51.1419 41.0801 50.933 41.0801C50.7241 41.0801 50.5547 41.2492 50.5547 41.4579C50.5547 41.6666 50.7241 41.8358 50.933 41.8358Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2305 43.7115V37.8887H52.1512",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4102 37.8887H47.3308",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8993 40.8715V42.8936C39.3749 42.8936 38.8719 42.6855 38.5011 42.3151C38.1302 41.9447 37.9219 41.4424 37.9219 40.9186C37.9219 40.858 37.9246 40.798 37.93 40.7388C38.0407 39.5124 39.8993 39.6401 39.8993 40.8715V40.8715Z",
    fill: "#EDEEEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8993 42.8949C39.3749 42.8949 38.8719 42.6868 38.5011 42.3165C38.1302 41.9461 37.9219 41.4437 37.9219 40.9199",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9506 45.1474C47.6878 45.1474 47.4275 45.0957 47.1847 44.9952C46.9419 44.8948 46.7213 44.7475 46.5354 44.5619C46.3496 44.3763 46.2021 44.1559 46.1016 43.9134C46.001 43.6709 45.9492 43.4109 45.9492 43.1484",
    stroke: "#FF6498",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1175 49.2969L38.9688 52.7702",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2305 43.7168L47.9531 44.0304",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4453 73.1973V104.056L69.2138 114.8V80.4323C69.2138 74.5106 67.2259 68.76 63.5679 64.0998C59.91 59.4396 54.7932 56.1389 49.0356 54.7255H49.0356C46.2313 54.0371 43.3069 53.9947 40.4837 54.6014C37.6606 55.2082 35.0125 56.4482 32.7399 58.2277C30.4672 60.0072 28.6295 62.2797 27.3658 64.8731C26.102 67.4665 25.4453 70.313 25.4453 73.1973L25.4453 73.1973Z",
    fill: "#EDEEEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8984 39.8812C39.8984 39.8812 42.5596 38.2963 42.4991 35.4811L47.3308 36.9348V35.0371L52.1493 36.9348V35.0371L54.1463 35.8363",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1175 37.8881C53.1175 37.8881 56.3712 36.1026 55.571 31.0409C55.571 31.0409 48.8138 27.1336 40.6341 31.0409L41.3454 28.1992C41.3454 28.1992 37.6762 29.7088 38.3224 31.8401L35.9219 32.0177L37.9232 33.4385C37.9232 33.4385 34.9669 36.7329 38.9119 39.881",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M35.921 56.207C35.921 56.207 9.33692 70.5574 7.20307 92.9354C5.06923 115.313 58.2974 103.592 63.0241 101.727C67.7509 99.8619 66.9507 96.1322 66.9507 96.1322C66.9507 96.1322 74.9526 92.9354 74.1524 92.669C73.3522 92.4026 29.3417 89.2057 29.3417 89.2057L42.4115 77.2175",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2383 58.977C58.2383 58.977 69.2201 65.0253 78.4668 82.4304C78.4668 82.4304 77.5294 55.978 85.8869 54.1656C94.2445 52.3532 95.4892 52.6035 93.8888 54.1656C92.2885 55.7277 89.799 56.2072 89.799 56.2072C89.799 56.2072 93.3554 61.9438 88.1986 63.0094C88.1986 63.0094 106.422 119.88 69.2147 104.055",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M198.182 236.906H194.367L213.251 193.814L215.784 195.673L198.182 236.906Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.356 236.906H125.5L144.384 193.814H213.24L194.356 236.906Z",
    fill: "#5100CE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M190.867 234.615H131.621L147.869 197.537H207.115L190.867 234.615Z",
    fill: "#EDEEEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M196.991 239.885H93.1289V234.613H199.114L196.991 239.885Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.991 239.885H93.1289V234.613H199.114L196.991 239.885Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M175.69 236.639H172.696C172.357 236.639 172.082 236.912 172.082 237.25C172.082 237.588 172.357 237.861 172.696 237.861H175.69C176.029 237.861 176.304 237.588 176.304 237.25C176.304 236.912 176.029 236.639 175.69 236.639Z",
    fill: "#D6D6D6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M183.366 236.639H180.372C180.033 236.639 179.758 236.912 179.758 237.25C179.758 237.588 180.033 237.861 180.372 237.861H183.366C183.705 237.861 183.98 237.588 183.98 237.25C183.98 236.912 183.705 236.639 183.366 236.639Z",
    fill: "#D6D6D6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.042 236.639H188.048C187.709 236.639 187.434 236.912 187.434 237.25C187.434 237.588 187.709 237.861 188.048 237.861H191.042C191.381 237.861 191.656 237.588 191.656 237.25C191.656 236.912 191.381 236.639 191.042 236.639Z",
    fill: "#D6D6D6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M131.621 234.615L147.869 197.537H207.115",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5391 239.887H212.374",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.29169c4a3fd590103d5550fab5a08806.svg";
export { ForwardRef as ReactComponent };